import { render, staticRenderFns } from "./Why2PayMe.vue?vue&type=template&id=6b4b0978&scoped=true&"
import script from "./Why2PayMe.vue?vue&type=script&lang=js&"
export * from "./Why2PayMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4b0978",
  null
  
)

export default component.exports